import { createSlice } from "@reduxjs/toolkit";
import type { CatalogTundish } from "../../../models/CatalogTundish";

const CatalogTundishInitialState: {
  tundishes: CatalogTundish[] | null;
} = {
  tundishes: null,
};

export const CatalogTundishReducer = createSlice({
  name: "__",
  initialState: CatalogTundishInitialState,
  reducers: {
    setTundishes(state, { payload }) {
      state.tundishes = payload;
    },
  },
});
